module.exports = __webpack_public_path__ + "img/classroom.f418e242.svg";